angular.module('CarsSaraBo').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when("/loader/new", {
        templateUrl: 'assets/carLoader/index.html',
        controller: 'CarLoaderController',
        title: 'carLoader.TITLE',
        sidebar: 'loadFleet'
    })
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/routes/car_loader_route.js
// module id = 809
// module chunks = 3